module.exports = __webpack_public_path__ + "static/media/announcement.e99101cb.png";